
import styled from 'styled-components';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { LinkButton } from 'styles-js/buttons';
import { titleMedium } from 'styles-js/mixins/typography';
import { useSelector } from 'src/store/store';
import { translationWithLink } from 'src/utils/i18n/translationUtils';
import i18n from 'src/utils/translate';
import ImproveSimilarToMeRecommendationsCard from 'src/modules/community/communityMembers/improveSimilarToMeRecommendationsCard';

export default function EmptyState() {
  const filter = useSelector(({ pages }) => pages.communityMembers.currentFilter);
  const { slug: communitySlug, name: communityName } = useSelector(({ context }) => context.currentCommunity);

  if (filter === 'similar-to-me') {
    return (
      <Empty>
        <p>{i18n.t('No one here yet!')}</p>
        <ImproveSimilarToMeRecommendationsCard />
      </Empty>
    );
  } else if (filter === 'roles') {
    return (
      <Empty>
        {i18n.t('This community is currently being moderated by HealthUnlocked: reports of abuse are reviewed and actioned when appropriate.')}{' '}
        <LinkButton onClick={() => helpScoutArticle('193-communities-moderated-by-healthunlocked')}>{i18n.t('Learn how')}{' >'}</LinkButton>
      </Empty>
    );
  } else {
    return (
      <Empty>
        {translationWithLink(i18n.t('No one here yet! %1$sInvite someone now%2$s'), {
          href: `mailto:?subject=${communityName}&body=I saw this new community and I thought you would like it: https://healthunlocked.com/${communitySlug}?ref=invite`,
        })}
      </Empty>
    );
  }
}

const Empty = styled.div`
  margin: 30px 0;
  width: calc(60% + 12px);
  @media (${({ theme }) => theme.underScreenSmall}) {
    width: 100%;
  }
  & > p {
    ${titleMedium};
    margin-bottom: 25px;
  }
`;
